import Workshop from "./Workshop";

function App() {
  return <Workshop />;
}

export default App;
